import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext({});
const KEY = "cart_lines_v1";

export const CartProvider = ({ children }) => {
  const [lines, setLines] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(lines)); }, [lines]);

  const add = (product, qty = 1) => {
    setLines((prev) => {
      const idx = prev.findIndex((l) => l.product_id === product.product_id);
      if (idx >= 0) {
        const c = [...prev];
        c[idx] = { ...c[idx], qty: c[idx].qty + qty };
        return c;
      }
      return [...prev, { product_id: product.product_id, qty, snapshot: { name_en: product.name_en, name_nl: product.name_nl, price: product.price, image: product.images?.[0], slug: product.slug } }];
    });
  };
  const setQty = (product_id, qty) => setLines((p) => p.map((l) => l.product_id === product_id ? { ...l, qty: Math.max(1, qty) } : l));
  const remove = (product_id) => setLines((p) => p.filter((l) => l.product_id !== product_id));
  const clear = () => setLines([]);
  const count = lines.reduce((s, l) => s + l.qty, 0);
  const subtotal = lines.reduce((s, l) => s + (l.snapshot?.price || 0) * l.qty, 0);

  return <CartCtx.Provider value={{ lines, add, setQty, remove, clear, count, subtotal }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
